import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { OPEN_IN_NEW_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const OpenInNewRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={OPEN_IN_NEW_ROUNDED_GLYPH} />;
